function CashFlow() {
    return (
        <div>
            <h2>Cash Flow</h2>

            <p>
                Your complete information comes here.
            </p>
        </div>
    );
}

export default CashFlow;